import React, { useState } from "react";
import { TreeItem } from "./TreeItem";
import "./styles.less";

export const Tree = (props) => {
  const { data, isRoot } = props;
  const [currentKey, setCurrentKey] = useState("");
  return (
    <div className="authing-menu-tree">
      {data.map((item, idx) => {
        return (
          <TreeItem
            key={`authing-menu-tree-${item.key}-${idx}`}
            data={item}
            isRoot={isRoot}
            currentKey={currentKey}
            setCurrentKey={setCurrentKey}
          />
        );
      })}
    </div>
  );
};
